import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  border-radius: 8px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
`;

export const Label = styled.div`
  padding: 4px 6px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.palette.NL0};
  position: absolute;
  bottom: 10px;
  left: 10px;
`;

export const Container = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL0};
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
`;

export const LabelWrapper = styled.div`
  margin-right: auto;
`;
